/* src/app/components/discovery/production-validation/production-validation.component.scss */
.main-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 2px 2px;
}
.content {
  margin: 12px 8px 0px 8px;
}
:host-context(.dark-theme) :host::ng-deep .mat-mdc-card {
  background-color: #3f3f3f;
}
:host-context(.dark-theme) :host::ng-deep .mat-mdc-card-content {
  background-color: #3f3f3f;
}
/*# sourceMappingURL=production-validation.component.css.map */
